import React from 'react';
import PropTypes from 'prop-types';
import * as S    from './footer.module.scss';

const FooterLinkGroup = ({title, links, cls}) => {
  return (
    <ul className={cls}>
      {title && (<li><span className={S.nolink}>{title}</span></li>)}
      {
        links && Object.entries(links).map((el, key) =>
          <li key={key}><a href={el[1]}>{el[0]} </a></li>
        )
      }
    </ul>
  );
};

FooterLinkGroup.displayName = 'FooterLinkGroup';

FooterLinkGroup.propTypes = {
  title: PropTypes.string,
  links: PropTypes.any,
  cls: PropTypes.string,
};

FooterLinkGroup.defalutProps = {
  links: null
};

export {FooterLinkGroup};
